import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "src/components/common/Breadcrumb/Breadcrumb";
import filterColumns from "./filterColumns";
import GenericGrid from "src/components/common/Grid/GenericGrid";
import { Spin } from "antd";
import TableFilter from "src/components/common/TableFilter/TableFilter";
import { Divider } from "@mui/material";

import { useEffect, useRef, useState } from "react";
import useRolePermission from "src/hooks/useRolePermission";
import Button from "src/components/common/Button/Button";
import { LocationListUploadModal } from "./LocationListUploadModal";
import { fetchLocationListUpdateSummary, MODULE_KEY } from "./actions";
import { ACTION } from "src/util/utils";
import { UploadOutlined } from "@ant-design/icons";
import { showErrorNotification } from "src/util/notifications";

export const LocationListUpdate = ({
  onCancel,
  importFile,
  params,
}: any) => {
  const dispatch = useDispatch();
  const { hasPermission } = useRolePermission();
  const [openUpload, setOpenUpload] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const hasMounted = useRef(false);
  const stateKey = `${MODULE_KEY}${ACTION.STATE_KEY}`;

  useEffect(() => {
    if (hasMounted.current) return;
    hasMounted.current = true;
    dispatch(fetchLocationListUpdateSummary({}));
  }, []);

  let filterValues = filterColumns();

  const handleCancel = () => {
    dispatch(fetchLocationListUpdateSummary({}));
  };

  

  return (
    <>
      <Spin spinning={filterValues.loading}>
        <Divider />
        <Breadcrumb>
          <span>Location List Update</span>
        </Breadcrumb>
        <TableFilter>
          <div className="form align-items-end flex"></div>
          <div className="d-flex justify-content-end gap-2">
            {hasPermission("locationlistupdate_import") && (
              <Button
                size="middle"
                icon={<UploadOutlined />}
                ant-click-animating-without-extra-node="true"
                onClick={() => setOpenUpload(true)}
              >
                {" "}
                Upload New Locations
              </Button>
            )}
          </div>
        </TableFilter>
        <GenericGrid
          columns={filterValues.columns}
          data={filterValues.data}
          enableRowSelection={false}
          rowSelection={[]}
          columnVisibility={{}}
          columnPinning={{}}
          enableColumnOrdering={false}
          filterDisplayMode="popover"
          highlightFilterMatch={true}
          paginationDisplayMode="pages"
          paginationProps={{
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            variant: 'outlined',
            rowsPerPageOptions: [10, 50, 100, 500, 1000]
          }}
          enableStickyHeader={true}
          enableStickyFooter={true}
          enableColumnPinning={true}
          isLoading={filterValues.loading}
          muiTableBodyCellProps={{
            sx: {
              fontSize: '11px',
              textAlign: 'center',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              padding: '2px 10px'
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontSize: '10px',
              fontWeight: '800',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              textAlign: 'center',
              padding: '2px 10px'
            }
          }}
          muiTableBodyRowProps={{
            sx: {
              "& td": {
                padding: "2px 10px",
              },
              textAlign: 'center',
            },
          }}
        >
        </GenericGrid>
        <LocationListUploadModal
          visible={openUpload}
          onCancel={() => setOpenUpload(false)}
          stateKey={stateKey}
          importFile={importFile}
          confirmLoading={confirmLoading}
          setConfirmLoading={setConfirmLoading}
        />
      </Spin>
    </>
  );
};